import React from 'react';
import { Menu, Typography } from 'antd';
import DatePickerr from './DatePickerr';
import DropdownState from './DropdownState';
import DropdownFilter from './DropdownFilter';
import SearchInput from './SearchInput';

interface Props {
  handleDateValue: Function;
  handleStateValue: Function;
  handleFilterValue: Function;
  handleInputValue: Function;
}

const stateBox = [
  // {
  //   title: '선택',
  //   value: ''
  // },
  {
    title: '일반회원',
    value: 'MEMBER'
  },
  {
    title: '가입신청자',
    value: 'SIGNUP_REQUEST'
  },
  {
    title: '수정신청자',
    value: 'AMENDMENT_REQUEST'
  },
  {
    title: '거절',
    value: 'REJECT'
  }
];
const filterBox = [
  // {
  //   title: '선택',
  //   value: ''
  // },
  {
    title: '아이디',
    value: 'email'
  },
  {
    title: '물류센터명',
    value: 'name'
  },
  {
    title: '국가',
    value: 'countryName'
  }
  // {
  //   title: '페이팔 계정 등록',
  //   value: 'paypalAccount'
  // }
];

function FilterAction({
  handleDateValue,
  handleStateValue,
  handleFilterValue,
  handleInputValue
}: Props) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '9px',
        marginBottom: '21px'
      }}
      className="busk-filter-action"
    >
      <DatePickerr handleDateValue={handleDateValue} />
      <Typography.Text style={{ fontSize: '1rem' }}>상태</Typography.Text>

      <DropdownState
        filterBy={stateBox}
        //filter
        handleStateValue={handleStateValue}
      />

      <DropdownFilter
        searchBy={filterBox}
        //filter
        handleFilterValue={handleFilterValue}
      />
      <SearchInput handleInputValue={handleInputValue} />
    </div>
  );
}

export default FilterAction;
